import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as newsletterApi from '../../api/newsletterApi';

export const subscribeNewsletter = createAsyncThunk(
  'newsletter/subscribe',
  async (payload, { rejectWithValue }) => {
    try {
      return await newsletterApi.subscribeNewsletter(payload);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors de l\'inscription.');
    }
  }
);

export const fetchNewsletters = createAsyncThunk(
  'newsletter/fetch',
  async (params = {}, { rejectWithValue }) => {
    try {
      return await newsletterApi.fetchNewsletters(params);
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur lors du chargement.');
    }
  }
);

const newsletterSlice = createSlice({
  name: 'newsletter',
  initialState: {
    list: [],
    loading: false,
    error: null,
    subscribeSuccess: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSubscribeSuccess: (state) => {
      state.subscribeSuccess = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscribeNewsletter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(subscribeNewsletter.fulfilled, (state, action) => {
        state.loading = false;
        state.subscribeSuccess = action.payload;
      })
      .addCase(subscribeNewsletter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchNewsletters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNewsletters.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload || [];
      })
      .addCase(fetchNewsletters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearSubscribeSuccess } = newsletterSlice.actions;
export default newsletterSlice.reducer;
